import Vue from 'vue'
import Vuex from 'vuex';
import request from "@/plugins/axios";
import {MessageBox} from "element-ui";
import router from "@/router";
import {childrenSort} from "@/utils/util";
import {CacheService} from "@/service/common";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    breadcrumb: [],
    auth: [],
    user: {},
    comp:{},
    compList: [],
    menu:[],
  },
  getters: {
    isAuth: state => (code, path) => {
      if (code) {
        return state.auth.find(item => item.authCode === code)
      } else {
        return state.auth.find(item => item.menuPath === path)
      }
    },
  },
  mutations: {
    setBreadcrumb(state, data) {
      switch (!!data.isNav) {
        case false: {
          //替换
          let sign = state.breadcrumb.find((item) => item.title == data.title);
          sign ? state.breadcrumb.pop() : state.breadcrumb.push(data);
          break;
        }
        case true: //添加
          state.breadcrumb = [data];
          break;
        // default:
        //   state.breadcrumb.splice(index, 1)
      }
    },
    setUser(state, payload) {
      state.user = payload.data
    },
    setComp(state, payload) {
      state.comp = payload.data
    },
    setCompList(state, payload) {
      state.compList = payload;
    },
    initMenu(state, payload) {
      state.menu = payload.filter(m => {
        let tag = true;
        if (!m.children && m.menuPath.indexOf('/') == -1) {
          tag = false
        }
        return tag && m;
      });
    },
  },
  actions: {

    getMenuData({commit, state}) {
      return new Promise((resolve, reject) => {
        request.get(`/Yunos/Menu/MyMenuTree?menuCls=5`).then((res) => {
          if (res.length) {
            const menus = res[0].children;
            let tag = true
            if (menus && menus.length) {
              let has = menus.some(m => m.children || m.menuPath.indexOf('/') !== -1)
              if (!has) tag = false
              // if (!menus[0].children && menus[0].menuPath.indexOf('/') == -1) {
              //     tag = false
              // }
            }
            if (!menus || !tag) {
              MessageBox.alert(
                  "您暂无该企业的相关菜单权限，请联系管理员添加!",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      // router.replace("/login");
                    },
                  }
              );
              return;
            }
            const menu = childrenSort(menus);
            let compInfo = CacheService.get("comp");
            //只有服务商认证才能创建第三方应用
            if(compInfo && compInfo.compLevel != 4){
                let tMenuIndex = menu.findIndex(_m=> _m.menuPath == '/Third-party');
                ~tMenuIndex&&menu.splice(tMenuIndex,1);
            }

            commit("initMenu", menu);
            resolve(menu);
          } else {
            MessageBox.alert(
                "您暂无该企业的相关菜单权限，请联系管理员添加!",
                "提示",
                {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    if (!state.auth.length) {
                      router.push("/login");
                    }
                  },
                }
            );
            return;
          }
          return reject(res);
        });
      });
    },
  },
  modules: {
  }
})
